import eventCardGql from "@/http/requests/card/event_gql";

export default {
	fetchEvents({ commit }, payload) {
		return new Promise((resolve, reject) => {
			eventCardGql
				.fetchEvents()
				.then(response => {
					commit("SET_EVENTS", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchEventsViolation({ commit }, payload) {
		return new Promise((resolve, reject) => {
			eventCardGql
				.fetchEventsViolation()
				.then(response => {
					commit("SET_EVENTS_VIOLATION", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
